import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getRoportDatasActions,
  setThecountBasedRenders,
  setTheoptions,
  getRoportpostActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Select from "react-select";
import validator from "validator";
import TagsInput from "react-tagsinput";

import "react-tagsinput/react-tagsinput.css";
import { useNavigate } from "react-router-dom";

const UserRolesheet = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const Navigate = useNavigate();
  const UserObjectData = useSelector((state) => state.users.UserData);

  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  const [sno, setsno] = useState(0);
  const [emailError, setEmailError] = useState("");
  const [Validattion, setValidation] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [inputValue, setInputValue] = useState("");
  const FileterState = {
    status: "",
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);

  const [emailList, setEmailList] = useState([]);
  const reportoptions = [
    { value: "user_role", label: "USER DESIGANTION REPORT" },
  ];
  const [emailTags, setEmailTags] = useState({ tags: [] });
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [EMpROleSelected, setEmpRoleSele] = useState(EmpRoles[0]);
  const [filterForWhite, setFilters] = useState({ white_collar: "" });

  const options = [
    { value: "", label: "ALL" },
    { value: "0", label: "Process" },
    { value: "1", label: "Success" },
    { value: "2", label: "Failed" },
  ];

  // STATUS_ = [("0", "Process"), ("1", "Success"), ("2", "Failed")]

  const [StatusVal, setStatusVal] = useState([{ value: "", label: "ALL" }]);
  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    setDisplay(SelectedValues);
    setdtPageindex(1);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));
    setStatusVal(SelectedValues);
    // console.log(values, "values");
    if (values == "Process") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "0",
      });
    } else if (values == "Failed") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "2",
      });
    } else if (values == "Success") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "1",
      });
    } else if (values == "") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  const HandleEMprole = (e) => {
    if (e != null) {
      setEmpRoleSele(e);
      setdtPageindex(1);

      if (e.value == 1) {
        // dispatch(setaRoleChnage(1));
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        // dispatch(setaRoleChnage(2)); ///Role based dispatch for the white_collar
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
      }
    }
  };

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      white_collar: filterForWhite.white_collar,
      status: selectVal.status,
      // report_type: 0,
    };
    dispatch(getRoportDatasActions(payload));
  }, [dtpageindex, filterForWhite, selectVal]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };

  const pageindex = (arg) => {
    setdtPageindex(arg);
  };
  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    setsearch(e);
    if (e.trim() != undefined && e.trim() != "") {
      const payload = {
        search: e.trim(),
        page_size: dtpagesize,
        page: 1,
        white_collar: filterForWhite.white_collar,
        status: selectVal.status,
      };
      dispatch(getRoportDatasActions(payload));
    }
    if (e == "" || search == "") {
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: 1,
        white_collar: filterForWhite.white_collar,
        status: selectVal.status,
      };
      dispatch(getRoportDatasActions(payload));
    }
  }
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
           if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p>{lastFourDigits}</p>; 
           }
        },
      },

      {
        Header: "EMAIL",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              {row.row.original.email && row.row.original.email != null ? (
                <span>
                  {row.row.original.email.map((item) => {
                    return <>{item}</>;
                  })}
                </span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Report",
        accessor: "",
        Cell: (row) => {
          const { report_type } = row.row.original;
          return (
            <>
              {row.row.original.report_type &&
              row.row.original.report_type != null ? (
                <span>{report_type == 0 ? "User Designation" : null}</span>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "Created Date",
        accessor: "",
        Cell: (row) => {
          const dateString = row.row.original.created_at;
          const dateObject = new Date(dateString);
          const hours = dateObject.getHours();
          const minutes = dateObject.getMinutes();
          const seconds = dateObject.getSeconds();
          const amOrPm = hours >= 12 ? "PM" : "AM";
          const twelveHourFormat = hours % 12 || 12;
          const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

          const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
          return (
            <>
              <span>
                {`${
                  row.row.original.created_at.slice(0, 10) +
                  "  " +
                  formattedTime
                }`}
              </span>
            </>
          );
        },
      },

      {
        Header: "STATUS",
        accessor: "status",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "0" ? (
                    <div className="StatusList">
                      <img src={Pendingimg} />
                      <span>{"Process"}</span>
                    </div>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() == "2" ? (
                        <div className="StatusList">
                          <div className="DeclineStatus">
                            <span>x</span>
                          </div>
                          <span>{"Failed"}</span>
                        </div>
                      ) : (
                        <>
                          {row.row.original.status.toLowerCase() == "1" ? (
                            <div className="StatusList">
                              <img src={correctIcons} />
                              <span>{"Success"}</span>
                            </div>
                          ) : null}
                        </>
                      )}
                    </>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },

      {
        Header: "DOWNLOAD",
        accessor: "",
        Cell: (row) => {
          const originalString = row.row.original.status;
          const capitalizedString = capitalizeFirstLetter(originalString);
          return (
            <>
              {row.row.original.status != undefined ? (
                <>
                  {row.row.original.status.toLowerCase() == "1" ? (
                    <div className="StatusList">
                      <span
                        style={{
                          padding: "5px 10px",
                          border: "1px solid red",
                          background: "#F05739",
                          color: "#fff",
                          borderRadius: "6px",
                          display: "flex",
                        }}
                        onClick={(e) => {
                          window.open(row.row.original.media_url);
                        }}
                      >
                        <i
                          class="fa-solid fa-download"
                          style={{ color: "#fff", paddingRight: "8px" }}
                        ></i>
                        Download
                      </span>
                    </div>
                  ) : (
                    <>{"---"}</>
                  )}
                </>
              ) : (
                <span>---</span>
              )}
            </>
          );
        },
      },
    ],

    [sno]
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setInputValue(value);

    if (!validator.isEmail(value)) {
      setEmailError("*Enter valid Email Id");
      setValidation(1);
    } else {
      setEmailError("");
      setValidation(0);
    }
  };

  const handleTagRemove = (indexToRemove) => {
    setEmailTags(emailTags.filter((_, index) => index !== indexToRemove));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const value = e.target.value;
      if (validator.isEmail(value)) {
        e.preventDefault();
        if (!emailTags.includes(value)) {
          setEmailTags([...emailTags, value]);
          setInputValue(""); // Clear input after adding
        }
      }
    }
  };

  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>User Designation</h3>
            <ul class="breadcrumb">
              <li class="breadcrumb-item">User Designation</li>
            </ul>


          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
            marginTop: "-30xp",
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div class=" col mt-3 ">
            <label for="validationCustom02" class="form-label FilterLabel">
              Employee Designation
            </label>

            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onChange={(e) => {
                HandleEMprole(e);
              }}
              value={EMpROleSelected}
              options={EmpRoles}
              placeholder="search"
            />
          </div>

          <div className="col mt-3">
            <label for="validationCustom01" class="form-label">
              REPORT
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              value={reportoptions}
              isDisabled
            />
          </div>
          <div className="col mt-3">
            <label for="validationCustom01" class="form-label">
              EMAIL
            </label>
            {/* <input
              type="text"
              value={inputValue}
              onChange={(e) => {
                handleInputChange(e);
              }}
              disabled={emailTags.length === 3}
              placeholder="Enter email and press Enter"
              class="form-control"
              // onKeyUp={(e) => {
              //   if (e.key === "Enter") {
              //     if (validator.isEmail(inputValue)) {
              //       e.preventDefault();
              //       handleInputChange(e);
              //     }
              //   }
              // }}
              onKeyDown={(e) => {
                //   if (e.key === "Enter") {
                //     e.preventDefault(); // Prevent form submission on Enter key
                //   }
                handleKeyDown(e);
              }}
            /> */}

            <TagsInput
              value={emailTags.tags}
              onChange={(e) => {
                // if (validator.isEmail(e)) {
                // setEmailTags({ ...emailTags, tags: e });

                // }
                e.map((item) => {
                  console.log(item, validator.isEmail(item), "item");
                  if (validator.isEmail(item)) {
                    setEmailTags({ ...emailTags, tags: e });
                    setEmailError("");
                  }
                  if (!validator.isEmail(item)) {
                    setEmailError("*Enter valid Email Id");
                  }
                  // setEmailError("*Enter valid Email Id");
                });
                console.log(e, "eemailTags", emailTags);
              }}
              placeHolder="Enter Email I'd"
              // class="form-control"
            />

            <p className="Error"> {emailError} </p>
          </div>
          {/* <div className="col-12">
            {emailTags.map((tag, index) => (
              <div
                key={index}
                style={{
                  display: "inline-block",
                  margin: "5px",
                  padding: "5px",
                  border: "1px solid #ccc",
                }}
              >
                {tag}
                <button
                  onClick={() => handleTagRemove(index)}
                  style={{
                    background: "#F04F39",
                    color: "white",
                    borderRadius: "4px",
                    marginLeft: "8px",
                    position: "relative",
                    // right: "-83px",
                  }}
                >
                  x
                </button>
              </div>
            ))}
          </div>
 */}
          <div className="row" style={{ marginTop: "30px", width: "100%" }}>
            <div className="col-6"></div>
            <div
              className="col-6"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <button
                className="ButtonCSS"
                style={{ background: "#EF4E39" }}
                onClick={(e) => {
                  const payload = {
                    data: {
                      report_type: "user_role",
                      email: emailTags.tags,
                    },
                    callactions: {
                      search: search,
                      page_size: dtpagesize,
                      page: 1,
                      white_collar: filterForWhite.white_collar,
                      status: selectVal.status,
                    },
                  };

                  dispatch(getRoportpostActions(payload));
                  setEmailTags({ ...emailTags, tags: [] });
                }}
              >
                Export
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          <ReactTable
            data={state.ReportSheetData.ReportSheetDATAS}
            columns={columns}
            totalItems={state.ReportSheetData.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.ReportSheetData.Total_Count}
            MakeCreate={false}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}

            ///--- emoloyee role based filters -
            Filter={true}
            EmployeeRoleTrue={false}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={EMpROleSelected}
            HandleEMprole={HandleEMprole}
            //---status

            value={StatusVal}
            options={options}
            count={count}
            ClearState={ClearState}
            placeHold={"All"}
            ApproveRequestFilter={true}
            setsno={setsno}
            sno={sno}
            id={"spe"}
          />
        </div>
      </div>
    </>
  );
};

export default UserRolesheet;
